import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { ThreeLinePreviewSkeleton } from './ThreeLinePreviewSkeleton';
export function InvoicePreviewSkeleton(props) {
    return /*#__PURE__*/ _jsx(ThreeLinePreviewSkeleton, _object_spread({}, props));
}
